module.exports = __webpack_public_path__ + "img/feedback-humaaans.9eeee8be.svg";